import { initializeSdk, logEvent } from '@eventbrite/statsig';
import { addPageToEvent } from '../utils';

export const STATSIG_EVENTS = {
    MODAL_OPEN: 'Ratings - Click - Component CTA',
    MODAL_CLOSE: 'Ratings modal - Click - Close Button',
    GET_DATA_SUCCESS: 'Ratings - Network Response - Success',
    GET_DATA_ERROR: 'Ratings - Network Response - Error',
    LOADED: 'Ratings - Loaded - Component',
    DISPLAYED: 'Ratings - Displayed - Component',
    NOT_DISPLAYED: 'Ratings - NotDisplayed - Component',
    LINK_HELPER_CENTER_CLICKED: 'Ratings modal - Click - Helper center link',
};

export const initializeStatsigSdk = async () => {
    await initializeSdk();
};

export const logModalOpen = (eventPage: string, organizerId: string) => {
    const RATING_MODAL_OPEN_EVENT = addPageToEvent(
        STATSIG_EVENTS.MODAL_OPEN,
        eventPage,
    );
    logEvent(RATING_MODAL_OPEN_EVENT, null, { organizerId });
};

export const logModalClose = (eventPage: string, organizerId: string) => {
    const RATING_MODAL_CLOSE_EVENT = addPageToEvent(
        STATSIG_EVENTS.MODAL_CLOSE,
        eventPage,
    );
    logEvent(RATING_MODAL_CLOSE_EVENT, null, { organizerId });
};

export const logGetDataSuccess = (eventPage: string, organizerId: string) => {
    const GET_DATA_SUCCESS_EVENT = addPageToEvent(
        STATSIG_EVENTS.GET_DATA_ERROR,
        eventPage,
    );
    logEvent(GET_DATA_SUCCESS_EVENT, null, { organizerId });
};

export const logGetDataError = (
    eventPage: string,
    organizerId: string,
    error: string,
) => {
    const GET_DATA_ERROR_EVENT = addPageToEvent(
        STATSIG_EVENTS.GET_DATA_ERROR,
        eventPage,
    );
    logEvent(GET_DATA_ERROR_EVENT, null, { organizerId, error });
};

export const logRatingsLoaded = (eventPage: string, organizerId: string) => {
    const RATING_LOADED_EVENT = addPageToEvent(
        STATSIG_EVENTS.LOADED,
        eventPage,
    );
    logEvent(RATING_LOADED_EVENT, null, { organizerId });
};

export const logRatingsDisplayed = (
    eventPage: string,
    organizerId: string,
    rating: number,
) => {
    const RATING_DISPLAYED_EVENT = addPageToEvent(
        STATSIG_EVENTS.DISPLAYED,
        eventPage,
    );
    logEvent(RATING_DISPLAYED_EVENT, rating, { organizerId });
};

export const logRatingsNotDisplayed = (
    eventPage: string,
    organizerId: string,
) => {
    const RATING_NOT_DISPLAYED_EVENT = addPageToEvent(
        STATSIG_EVENTS.NOT_DISPLAYED,
        eventPage,
    );
    logEvent(RATING_NOT_DISPLAYED_EVENT, null, { organizerId });
};

export const logRatingHelperCenterClick = (
    eventPage: string,
    organizerId: string,
    link: string,
) => {
    const LINK_HELPER_CENTER_CLICKED_EVENT = addPageToEvent(
        STATSIG_EVENTS.LINK_HELPER_CENTER_CLICKED,
        eventPage,
    );
    logEvent(LINK_HELPER_CENTER_CLICKED_EVENT, link, { organizerId });
};
